import { Step } from "types/steps";
import { api } from "./api";

const fetchSteps = async (): Promise<Step[]> => {
  try {
    const { data } = await api.get("/database/etapas__c");

    return data;
  } catch (error: any) {
    throw error;
  }
};

export { fetchSteps };
